import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'
import { CommentButtonProps } from '@widgets/HeadlineLead/types'
import SvgIcon from '@components/SvgIcon'

const StyledButton = styled.button`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        grey: { grey_80 },
        brandColors: { brand_55 },
      },
    },
  }) => {
    return css`
      margin-left: 10px;
      padding: 10px 15px;
      border-radius: 100px;
      background-color: transparent;
      font-family: ${goodOT};
      font-weight: 500;
      font-size: 16px;
      line-height: 1;
      cursor: pointer;
      border-radius: 25px;
      border: 1px solid ${grey_80};
      color: ${grey_80};
      margin-left: auto;
      justify-self: flex-end;
      svg {
        stroke: ${grey_80};
        stroke-width: 1.5;
      }
      &:hover {
        border-color: ${brand_55};
        color: ${brand_55};
        svg {
          stroke: ${brand_55};
        }
      }
    `
  }}
`

const StyledSvgIconWrapper = styled.span`
  vertical-align: text-bottom;
  margin-right: 4px;
`

const CommentButton: FunctionComponent<CommentButtonProps> = ({
  onClick,
  children,
}) => {
  const theme = useTheme()

  return (
    <StyledButton onClick={onClick}>
      <StyledSvgIconWrapper>
        <SvgIcon
          iconName="chatbubble-outline"
          size={16}
          color={theme.colors.grey.grey_80}
        />
      </StyledSvgIconWrapper>
      {children}
    </StyledButton>
  )
}

export default CommentButton
